export default "__VITE_ASSET__23668a42__"